import type { IconData } from '@stacksjs/iconify-core'

export const cg1x1: IconData = {
  "body": "<defs><clipPath id=\"SVGgq5eKdgv\"><path fill-opacity=\".7\" d=\"M115.7 0h496.1v496h-496z\"/></clipPath></defs><g fill-rule=\"evenodd\" stroke-width=\"1pt\" clip-path=\"url(#SVGgq5eKdgv)\" transform=\"translate(-119.5)scale(1.032)\"><path fill=\"#ff0\" d=\"M0 0h744v496H0z\"/><path fill=\"#00ca00\" d=\"M0 0v496L496 0z\"/><path fill=\"red\" d=\"M248 496h496V0z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default cg1x1
